/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invalid_Barcode_HolderInputs */

const vi_error_invalid_barcode_holder = /** @type {(inputs: Error_Invalid_Barcode_HolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không xác định được sản phẩm đang giữ mã vạch. Tải lại trang rồi lưu lại.`)
};

/**

* @param {Error_Invalid_Barcode_HolderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_invalid_barcode_holder = /** @type {((inputs?: Error_Invalid_Barcode_HolderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invalid_Barcode_HolderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_invalid_barcode_holder(inputs)
});